/**
 * Type that can contain only the ID values of the icons in this bundle.
 */

/**
 * Checks whether given value is valid {@see VirtualTourIconId}.
 */
export function isVirtualTourIconId(value, iconBundle) {
  return value in iconBundle.icons.urls;
}